import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import { trackPageView, useScrollDepth } from "@/utils/analytics";
import { ModalProvider } from "@/context/ModalContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import PageLayout from "@components/layout/PageLayout";
import HomePage from "@pages/HomePage";

const CatalogPage = lazy(() => import("@pages/CatalogPage"));
const GalleryPage = lazy(() => import("@pages/GalleryPage"));
const ServicesPage = lazy(() => import("@pages/ServicesPage"));
const AboutPage = lazy(() => import("@pages/AboutPage"));
const ContactsPage = lazy(() => import("@pages/ContactsPage"));
const NotFoundPage = lazy(() => import("@pages/NotFoundPage"));

export default function App() {
  const location = useLocation();
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);
  useScrollDepth(location.pathname);

  return (
    <SiteSettingsProvider>
      <ModalProvider>
      <Suspense fallback={null}>
        <Routes>
          <Route element={<PageLayout />}>
            <Route index element={<HomePage />} />
            <Route path="catalog" element={<CatalogPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
      </ModalProvider>
    </SiteSettingsProvider>
  );
}
